import * as React from "react";
import { forwardRef } from "react";
const SvgArrowDownSmall = ({
  title,
  titleId,
  ...props
}, ref) => <svg width={12} height={7} viewBox="0 0 12 7" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<g fill="none" fillRule="evenodd"><path d="M0 0v7h12V0z" /><path stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" d="M1.757 1.243 6 5.485l4.243-4.242" /></g></svg>;
const ForwardRef = forwardRef(SvgArrowDownSmall);
export { ForwardRef as ReactComponent };